import { gql } from '@lojinha/palantir'

export const GET_DATA_INDICATIONS = gql`
  query GetIndicationInfo {
    viewer {
      user {
        id
        referralCredit
        referralCouponCode
        referralRewardAmount
        referralDiscount
        ownCoupon {
          usageCount
        }
        couponUsages {
          totalCount
          nodes {
            userName
            amount
          }
        }
      }
    }
  }
`
